<div class="service-page">
  <header class="page-hero">
    <p class="eyebrow">Desarrollo web en Segovia</p>
    <h1>Desarrollo y diseño web en Segovia para empresas.</h1>
    <p class="hero-lead">
      Diseñamos y desarrollamos páginas web profesionales para empresas de Segovia que necesitan
      explicar mejor sus servicios, generar confianza y facilitar el contacto con sus clientes.
    </p>
    <a class="button button-primary" routerLink="/contacto">Solicitar una valoración</a>
  </header>

  <section class="split-section" aria-labelledby="local-service-title">
    <div class="section-heading">
      <p class="eyebrow">Servicio local</p>
      <h2 id="local-service-title">
        Cercanía para entender el negocio. Método para construir la web.
      </h2>
    </div>
    <div>
      <p>
        ATSIestudio trabaja desde Segovia con autónomos, pequeñas empresas y negocios locales. La
        proximidad permite reunirnos y conocer el contexto de primera mano cuando el proyecto lo
        necesita, sin renunciar a un proceso digital ordenado.
      </p>
      <p>
        Cada web se plantea a partir de un objetivo concreto: presentar la empresa, ordenar sus
        servicios, captar solicitudes o renovar una presencia digital que se ha quedado atrás.
      </p>
    </div>
  </section>

  <section aria-labelledby="segovia-scope-title">
    <div class="section-heading">
      <p class="eyebrow">Qué incluye</p>
      <h2 id="segovia-scope-title">Una web preparada para representar bien a tu empresa.</h2>
      <p>El alcance se adapta a las necesidades, el contenido y el presupuesto de cada proyecto.</p>
    </div>
    <div class="feature-grid">
      <article>
        <span>01</span>
        <h3>Landing pages y webs profesionales</h3>
        <p>Ordenamos la información para que cada servicio se entienda y sea fácil de encontrar.</p>
      </article>
      <article>
        <span>02</span>
        <h3>Diseño y desarrollo responsive</h3>
        <p>Creamos una experiencia profesional que funciona en móvil, tablet y escritorio.</p>
      </article>
      <article>
        <span>03</span>
        <h3>Webs avanzadas e integraciones</h3>
        <p>
          Construimos una base rápida, accesible y mantenible con las funcionalidades necesarias.
        </p>
      </article>
      <article>
        <span>04</span>
        <h3>Optimización y soporte técnico</h3>
        <p>Preparamos una base técnica ordenada y el mantenimiento que el proyecto necesite.</p>
      </article>
    </div>
  </section>

  <section class="decision-section" aria-labelledby="custom-title">
    <div class="section-heading">
      <h2 id="custom-title">Más que instalar una plantilla.</h2>
    </div>
    <div>
      <p>
        Una página web puede ser el comienzo, no el límite. Cuando una empresa necesita conectar
        servicios, simplificar tareas o resolver un proceso interno, planteamos una solución a
        medida con aplicaciones web, integraciones, APIs y automatizaciones solo cuando aportan
        valor.
      </p>
      <p>
        Puedes conocer el alcance de nuestro
        <a routerLink="/servicios/desarrollo-personalizado">desarrollo personalizado</a> y valorar
        qué encaja con tu situación antes de decidir.
      </p>
    </div>
  </section>

  <section class="split-section" aria-labelledby="local-audience-title">
    <div class="section-heading">
      <p class="eyebrow">Para empresas de Segovia</p>
      <h2 id="local-audience-title">Una solución proporcionada al momento de tu negocio.</h2>
    </div>
    <ul class="check-list">
      <li>Autónomos que necesitan su primera web profesional.</li>
      <li>Negocios locales que quieren recibir más solicitudes desde internet.</li>
      <li>Pymes que necesitan renovar una página desactualizada.</li>
      <li>Empresas que requieren funcionalidades o integraciones a medida.</li>
    </ul>
  </section>

  <section class="split-section" aria-labelledby="process-title">
    <div class="section-heading">
      <h2 id="process-title">Un proceso claro desde la primera conversación.</h2>
      <p>Definimos cada paso para que sepas qué se va a hacer y cuál es el siguiente movimiento.</p>
    </div>
    <ol class="check-list">
      <li>Entendemos la necesidad, el punto de partida y los objetivos del negocio.</li>
      <li>Preparamos una propuesta con alcance y precio acordados.</li>
      <li>Diseñamos y desarrollamos la solución.</li>
      <li>Revisamos el resultado contigo antes de publicarlo.</li>
      <li>Lanzamos la web con una base técnica preparada para funcionar bien.</li>
      <li>Podemos continuar con mantenimiento y soporte técnico después del lanzamiento.</li>
    </ol>
  </section>

  <section class="decision-section" aria-labelledby="projects-title">
    <div class="section-heading">
      <h2 id="projects-title">Proyectos reales que puedes comprobar.</h2>
    </div>
    <div>
      <p>
        El trabajo de ATSIestudio se apoya en proyectos publicados, no en ejemplos genéricos. En
        <a routerLink="/proyectos">nuestros proyectos</a> puedes conocer Skepsis Ink, una web real
        desarrollada para presentar el trabajo y facilitar el contacto de un negocio de Segovia.
      </p>
    </div>
  </section>

  <section class="split-section" aria-labelledby="maintenance-title">
    <div class="section-heading">
      <h2 id="maintenance-title">La web no termina el día del lanzamiento.</h2>
    </div>
    <div>
      <p>
        Si lo necesitas, seguimos cuidando la parte técnica del proyecto para que la web se mantenga
        actualizada, operativa y alineada con la evolución del negocio.
      </p>
      <a class="text-link" routerLink="/servicios/mantenimiento">Conoce el mantenimiento web</a>
    </div>
  </section>

  <section class="faq-section" aria-labelledby="local-faq-title">
    <div class="section-heading">
      <p class="eyebrow">Preguntas frecuentes</p>
      <h2 id="local-faq-title">Sobre el desarrollo web en Segovia.</h2>
    </div>
    <div class="faq-list">
      <details>
        <summary>¿Trabajáis solo con empresas de Segovia?</summary>
        <p>
          No. ATSIestudio está en Segovia y trabaja con empresas de toda España. Para negocios de la
          zona podemos combinar reuniones presenciales y seguimiento online según convenga.
        </p>
      </details>
      <details>
        <summary>¿Cuánto cuesta una página web en Segovia?</summary>
        <p>
          Una landing esencial parte de 690 € más IVA y una web profesional, de 1.290 € más IVA. El
          presupuesto final depende del número de páginas, los contenidos y las funcionalidades.
        </p>
      </details>
      <details>
        <summary>¿Cuánto se tarda en desarrollar una web?</summary>
        <p>
          El plazo se acuerda tras definir el alcance, los contenidos y las integraciones
          necesarias. El proceso incluye propuesta, diseño y desarrollo, revisión, lanzamiento y
          mantenimiento si el proyecto lo requiere.
        </p>
      </details>
      <details>
        <summary>¿Podéis renovar una web existente?</summary>
        <p>
          Sí. Una web existente puede ser el punto de partida. Antes de proponer el trabajo
          revisamos su estado, contenidos, objetivos y las mejoras que aportarían valor.
        </p>
      </details>
      <details>
        <summary>¿La web estará preparada para aparecer en Google?</summary>
        <p>
          Sí. El desarrollo incluye una base técnica indexable y una estructura coherente para
          buscadores. El posicionamiento posterior depende también del contenido, la competencia, la
          autoridad del dominio y la presencia local del negocio.
        </p>
      </details>
      <details>
        <summary>¿Ofrecéis mantenimiento después del lanzamiento?</summary>
        <p>
          Sí. Podemos continuar con el mantenimiento web y el soporte técnico, con un alcance
          adaptado a las necesidades de cada proyecto.
        </p>
      </details>
      <details>
        <summary>¿Podéis desarrollar funcionalidades a medida?</summary>
        <p>
          Sí. Cuando el negocio lo necesita, desarrollamos aplicaciones web, integraciones,
          automatizaciones y herramientas internas a medida.
        </p>
      </details>
    </div>
  </section>

  <section class="service-cta" aria-labelledby="local-cta-title">
    <p class="eyebrow">Hablemos</p>
    <h2 id="local-cta-title">Cuéntanos qué necesita tu empresa en Segovia.</h2>
    <p>Explícanos el punto de partida y te ayudaremos a definir los siguientes pasos.</p>
    <a class="button button-primary" routerLink="/contacto">Cuéntanos tu proyecto</a>
  </section>
</div>
